import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SubTabNoData(props) {
  return (
    <div className='slp-subtab-no-data'>
      <FontAwesomeIcon icon={props.icon} size='8x' />
      <h1>{props.title}</h1>
      <p>{props.description}</p>
    </div>
  )
}

export default SubTabNoData;